export const RouteFallback = () => {
  return (
    <div
      className="flex min-h-[60vh] items-center justify-center"
      role="status"
      aria-live="polite"
    >
      <span className="text-sm text-secondary-600">Đang tải...</span>
    </div>
  );
};
